export default __webpack_public_path__ + "check-list-icon.svg";